import React, { Component } from "react";
import "./style.scss";
import { Tab } from "../../presentationals";

class NavBar extends Component {
  state = {
    menuIsVisible: false,
  };

  links = [
    { path: "/", name: "Home" },
    { path: "/formations", name: "Formations" },
    { path: "/experiences", name: "Experiences" },
    { path: "/projets", name: "Projets" },
    { path: "/cv", name: "Cv" },
  ];

  toggleVisibility = () => {
    this.setState((prevState) => ({ menuIsVisible: !prevState.menuIsVisible }));
  };

  renderLinks = () => {
    return (
      <div
        className={`tabs-wrapper${this.state.menuIsVisible ? " visible" : ""}`}
        onClick={this.toggleVisibility}
      >
        {this.links.map((link) => (
          <Tab name={link.name} path={link.path} key={link.name} />
        ))}
      </div>
    );
  };

  render() {
    return (
      <nav className="navbar">
        <a
          href="https://www.linkedin.com/in/tanguy-heller/"
          className="logo-wrapper"
        >
          <img src="/images/linkedin.svg" alt="logo" />
          <div className="title">Tanguy HELLER</div>
        </a>
        <div className="spacer"></div>
        <div
          className="menu-burger"
          onClick={this.toggleVisibility}
          style={{
            backgroundImage: `url(/images/${
              this.state.menuIsVisible ? "delete_white" : "list_white"
            }.png)`,
          }}
        />
        {this.renderLinks()}
      </nav>
    );
  }
}

export default NavBar;
